// TODO: Move to constants?
export const FEATURE_FLAGS_LOCAL_STORAGE_KEY =
  "platform-sh-console-feature-flags";

export const FEATURE_FLAGS = [
  "ENABLE_ACCOUNT_SECURITY_ROUTE",
  "ENABLE_ADD_DOMAIN_SUPPORT",
  "ENABLE_ADD_PROJECT_USER_PRICING_AGREEMENT",
  "ENABLE_SECURITY_ENFORCEMENT_BANNER",
  "ENABLE_ANNOUNCEMENTS",
  "ENABLE_AUTOSCALING",
  "ENABLE_BILLING",
  "ENABLE_BILLING_ACCOUNTS_MENU",
  "ENABLE_BLACKFIRE_CARD",
  "ENABLE_CARBON_EMISSIONS_DASHBOARD",
  "ENABLE_CONNECTED_ACCOUNTS_ROUTE",
  "ENABLE_CONTAINERS_RELATIONSHIPS_DETAILS",
  "ENABLE_CONTAINERS_SERVICE_LINKS",
  "ENABLE_CREATE_PROJECT",
  "ENABLE_CHANGE_USERNAME_EMAIL",
  "ENABLE_EDIT_PLAN",
  "ENABLE_SETTINGS_RESOURCES",
  "ENABLE_ENVIRONMENT_DOMAINS",
  "ENABLE_FIRST_PROJECT_INCENTIVE",
  "ENABLE_FREE_TRIAL_DIALOG",
  "ENABLE_GREEN_DISCOUNT",
  "ENABLE_HIPAA_COMPLIANCE",
  "ENABLE_OBSERVABILITY_SUITE_INTEGRATIONS",
  "ENABLE_ORGANIZATION",
  "ENABLE_CREATE_ORGANIZATION",
  "ENABLE_PROJECT_SETUP_WIZARD",
  "ENABLE_PROJECT_PROVISIONING_WIZARD",
  "ENABLE_PROJECT_SETUP_TIPS",
  "ENABLE_RESET_PROFILE_PASSWORD",
  "ENABLE_SENTRY",
  "ENABLE_SERVICES_AUTOSCALING",
  "ENABLE_IMAGES_LIFECYCLE_MANAGEMENT",
  "ENABLE_SERVICE_TREE",
  "ENABLE_STAFF_TEST_MODE",
  "ENABLE_UNBRANDED_ILLUSTRATIONS",
  "ENABLE_USAGE_BASED_BILLING_PAGES",
  "ENABLE_NOTIFICATION_SETTINGS",
  "ENABLE_HTTP_METRICS",
  "ENABLE_VOUCHERS",
  "ENABLE_PROFILING",
  "DISABLE_ALL_PROJECTS",
  "ENABLE_ORGANIZATION_PLANS_PERMISSION",
  "ENABLE_CUSTOM_LEFT_PANEL",
  "ENABLE_LOCAL_DEPLOYMENT_TARGET",
  "ENABLE_TOTAL_RESOURCE_ALLOCATION_METRICS",
  "ENABLE_CONTINUOUS_PROFILING_SELLABLE",
  "ENABLE_PROJECT_ACCESS_SELECT",
  "ENABLE_SUPPORT_SELLABLE",
  "ENABLE_CUSTOM_BANNER_MESSAGE",
  "ENABLE_SOURCE_REPOSITORY_TOOLTIP",
  "ENABLE_ENVIRONMENT_SOCKET",
  "ENABLE_DISCLAIMER_GENERAL_SUPPORT",
  "ENABLE_REACTIVATE_TRIAL",
  "ENABLE_RESOURCE_ALLOCATION_PRICING",
  "ENABLE_REDUCED_WIZARD",
  "ENABLE_COMMAND_MENU",
  "ENABLE_COMMAND_MENU_DOCS",
  "ENABLE_MAINTENANCE_WINDOW",
  "ENABLE_MODAL_REDIRECTION_DOCS",
  "ENABLE_PROJECT_TRAFFIC_BLOCK",
  "ENABLE_INTERNAL_SERVICE_METRICS",
  "ENABLE_METRICS_EXPLORER",
  "ENABLE_ORGANIZATION_TYPE_DISPLAY",
  "ENABLE_PLUGIN_APP",
  "ENABLE_DEPLOYMENT_STRATEGIES",
  "ENABLE_RESOURCE_METRICS",
  // Vendor-level master switch: gates the environment observability tabs
  // (Metrics, HTTP Traffic, Logs) for everyone — including staff — overriding
  // the per-tab ENABLE_* flags. Enabled per vendor; Adobe Commerce sets it false
  // to hide the tabs entirely.
  "ENABLE_OBSERVABILITY_TABS",
  "ENABLE_OCI_DOCKER",
  "ENABLE_TRIAL_USAGE",
  // Vendor opt-in: keep the classic empty-org flow (empty state + provisioning
  // card) instead of Upsun's automatic org-creation onboarding ("Upsun engine
  // initializing" loader), which otherwise runs for every non-fixed org. Adobe
  // Commerce sets it true so new projects show the ProvisioningCard again.
  "ENABLE_PROVISIONING_CARD",
  "ENABLE_CONFIG_DIFFS",
  "ENABLE_ZENDESK_LINKS",
  "ENABLE_CRONS",
  "ENABLE_OBJECT_STORAGE",
  // Vendor-level switch for the Backups tab and route. Adobe Commerce sets it
  // false to hide Backups entirely.
  "ENABLE_BACKUPS",
  // Serves the user SSH keys page from the auth API
  // (/users/{userId}/ssh-keys) instead of the legacy accounts /ssh_keys
  // endpoints and the ssh_keys field of the legacy /me payload.
  "ENABLE_SSH_KEYS_API"
] as const;

export const CUSTOMIZATIONS = ["CUSTOM_CONFIG_DIR_NAME"] as const;

export type FeatureFlagName =
  (typeof FEATURE_FLAGS)[number] | (typeof CUSTOMIZATIONS)[number];

export type FeatureFlags = Record<FeatureFlagName, boolean>;
